/**
 * Часовой пояс Заказчика: сервер хранит время в UTC, а показывает его
 * в поясе из настроек (приходит в профиле при входе).
 */
let dateTime: Intl.DateTimeFormat;
let timeOnly: Intl.DateTimeFormat;

export function setTimeZone(tz: string) {
  try {
    dateTime = new Intl.DateTimeFormat("ru-RU", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: tz,
    });
    timeOnly = new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit", timeZone: tz });
  } catch {
    // Неизвестный браузеру пояс — остаёмся на прежнем.
  }
}

setTimeZone("Europe/Moscow");

export const fmtDateTime = (iso: string | null) => (iso ? dateTime.format(new Date(iso)) : "—");
export const fmtTime = (iso: string | null) => (iso ? timeOnly.format(new Date(iso)) : "—");

export function fmtDuration(fromISO: string, toISO: string | null): string {
  if (!toISO) return "не завершён";
  const min = Math.round((new Date(toISO).getTime() - new Date(fromISO).getTime()) / 60000);
  const h = Math.floor(min / 60);
  return h > 0 ? `${h} ч ${min % 60} мин` : `${min} мин`;
}

export function fmtDistance(m: number | null): string {
  if (m === null) return "—";
  return m >= 1000 ? `${(m / 1000).toFixed(1)} км` : `${Math.round(m)} м`;
}

export function fmtSize(bytes: number): string {
  return bytes >= 1 << 20 ? `${(bytes / (1 << 20)).toFixed(1)} МБ` : `${Math.round(bytes / 1024)} КБ`;
}

// Те же слова, что в приложении инспектора: «Срочно», «Обычно», «Не срочно».
export const priorityName = (p: number) =>
  ({ 1: "Срочно", 2: "Высокий", 3: "Обычно", 4: "Не срочно" })[p] ?? String(p);

export const incidentStatusName: Record<string, string> = {
  new: "Новое",
  seen: "Просмотрено",
  in_progress: "В работе",
  forwarded: "Передано",
  closed: "Закрыто",
  rejected: "Отклонено",
};

export const verdictName: Record<string, string> = {
  ok: "Пройдена",
  no_fix: "Пройдена, без координат",
  out_of_radius: "Пройдена, вне радиуса",
  wrong_route: "Метка другого маршрута",
  unknown_tag: "Метка вне реестра",
  blocked_tag: "Метка заблокирована",
  duplicate: "Повторное считывание",
};

export const trackEventName: Record<string, string> = {
  gps_lost: "Потеря сигнала GPS",
  gps_restored: "Сигнал GPS восстановлен",
  location_off: "Геолокация выключена",
  permission_lost: "Отозвано разрешение на геолокацию",
  service_killed: "Служба записи остановлена системой",
  service_restored: "Запись возобновлена",
  mock_detected: "Обнаружена подмена координат",
  clock_changed: "Изменено системное время",
  device_rebooted: "Устройство перезагружено",
};

export const roleName: Record<string, string> = {
  inspector: "Инспектор",
  chief: "Начальник заповедника",
  director: "Директор",
  scientist: "Научный сотрудник",
  admin: "Администратор",
};
